import { useFormContext } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import { ValoresRateio } from "./DisplayRateio/DialogAdicionar";

export default function InfoStep04() {

    const { getValues } = useFormContext()
    const { step04 } = getValues()
    const possuiRateio = step04.add_rateio === 'true'
    const rateios: ValoresRateio[] = step04.rateios

    return (
        <>
            <Box display={'flex'} flexDirection={'column'} >
                {
                    !possuiRateio &&
                    <Typography variant="subtitle2" color="textSecondary">Não possui rateio</Typography>
                }

                {
                    possuiRateio &&
                    <>
                        <Typography variant="subtitle2" color="textSecondary">Divisão por centro de custo</Typography>
                        <Box overflow={'auto'} display={'flex'} maxWidth={300} flexDirection={'column'} flexWrap={'wrap'} gap={0}>
                            {
                                rateios.map((item, index) => {
                                    return (
                                        <Box key={index} display="flex" gap={1} my={0.5}>
                                            <Typography variant="subtitle2">
                                                {`${index + 1}º) ${item.contaDevedora?.codigo_contabil} - ${item.contaDevedora?.nome}`}
                                            </Typography>
                                            <Box
                                                flex={1}
                                                borderBottom="1px dotted black"
                                                sx={{ boxSizing: "border-box", height: '14px' }}
                                            />
                                            <Typography variant="subtitle2">{item.valor}</Typography>
                                        </Box>
                                    )
                                })
                            }
                        </Box>
                    </>
                }
            </Box>
        </>
    )
}